/*
 *  -----------------------------------------------------------------------
 *    <copyright file="app.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { Theme } from '@mui/material/styles';

const drawerWidth = 240;

export const appStyles = (theme: Theme) => ({
    root: {
        display: 'flex',
        height: '100vh',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        backgroundColor: 'white',
        flexGrow: 1,
        // padding: theme.spacing(1.25), // This padding has been moved to the router, so that components can decide if they want padding or not.
        paddingTop: 0,
        overflowX: 'hidden' as const, // Note: See https://github.com/emotion-js/emotion/issues/1179
    },
});
